<template>
  <section>
    <div>
      <hr>
      <b-tabs
        v-model="tabIndex"
        small
        content-class="mt-3"
        @activate-tab="clickedTab"
      >
        <b-tab
          ref="listTab"
          title="Lista"
          active
        >
          <CampaignResultTable
            @sort-changed="onSort"
            @exclude-rows="submitExcludeRows"
          />
        </b-tab>
        <b-tab
          title="Räckvidd och frekvens"
          :disabled="!hasSelection"
        >
          <CampaignReach @onCampaignSearchReach="campaignSearchReach" />
        </b-tab>
        <template v-slot:tabs-end>
          <div
            v-if="tabIndex === 0"
            class="sumexportbtnswrapper"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              :disabled="measuresInTable.length === 0"
              @click="showOrHideSumInTable"
            >
              {{ sumVisible ? "Göm Summering" : "Visa Summering" }}
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="exportResult"
            >
              <b-icon icon="arrow-repeat" />
              Exportera
            </b-button>
          </div>
        </template>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import CampaignResultTable from './CampaignResultTable.vue';
import CampaignReach from './CampaignReach.vue';
import { mapActions } from 'vuex';
import { bus } from '../../../main';
import { downloadFile } from '../../../assets/js/api.js';
import { search } from '../../../assets/js/api.js';
import { processCampaignResults } from '../../../assets/js/utils.js';

export default {
  name: 'CampaignResult',
  components: {
    CampaignResultTable,
    CampaignReach,
  },

  data() {
    return {
      tabIndex: 0,
      loadingSearchResults: false
    }
  },
  computed: {
    sumVisible() {
      return this.$store.getters[`campaignResults/getSumVisible`];
    },
     hasSelection() {
       let selection = this.$store.state.campaignReachApiBody.payload.queryKeys.length > 0;  
       return selection;
     },
     measuresInTable() {
      return this.$store.getters[`campaignResults/getMeasuresInTable`];
    },
    hasExcludedRows() {
      let result = this.$store.state.campaignResults;
      return result.totalRowCount !== result.results.length;
    },
  },
  mounted() {
    bus.$on('searching', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
        this.$store.commit('campaignReachApiBody/emptyQueryKeys');
        this.$store.commit('campaignResults/unselectAll');
      }
    });
  },
  methods: {
    ...mapActions(['campaignSearchReach']),
    onSort(item) {
      this.$emit('sort-only', item);
    },
    async clickedTab(newTabIndex, prevTabIndex) {
      if(newTabIndex === prevTabIndex) return
      if (newTabIndex === 1)
        this.campaignSearchReach()
    },
    showOrHideSumInTable(){
      this.$store.commit('campaignResults/setSumVisible', !this.sumVisible);
    },
    async submitExcludeRows() {
      this.loadingSearchResults = true;
      const apiBody = this.$store.state.campaignApiBody;
      
      try {
        const response = await search('QueryCampaignData', apiBody);
        this.$store.commit('campaignResults/updateRowCount', response.info.total_row_count);
        processCampaignResults(response, this.$store);
      } catch (error) {
        this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 10000,
        });     
        this.$store.commit('campaignResults/updateResults', []);
        this.$store.commit('campaignResults/updateResultFields', []);
      } finally {
        this.loadingSearchResults = false;
      }
    },
    async exportResult() {
      try {
        let payload = {...this.$store.state.campaignApiBody};
        await downloadFile('QueryCampaignData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        // Show error to user
        this.$bvToast.toast('Ett fel uppstod vid export av data. Försök igen senare.', {
          title: 'Export misslyckades',
          variant: 'danger',
          solid: true
        });
      }
    },
  },
};
</script>
